import { GrantsType, hasScopedPermission } from '../../Shared/utils/auth';
import { viewSystemPolicies } from './viewSystemPolicies';

export const viewPolicyScopeToggle = (grants: GrantsType) =>
  !viewSystemPolicies(grants) &&
  hasScopedPermission(grants, 'partner', 'policies.read') &&
  hasScopedPermission(grants, 'user', 'policies.read');
